import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: '/'
  },
  {
    path: '/',
    component: () => import(/* webpackChunkName: "store" */ '@/layouts/StoreLayout.vue'),
    children: [
      {
        path: '/',
        name: 'Home',
        component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
        meta: { showFooterInMobile: true }
      },
      {
        path: 'product/:slug',
        name: 'Product-detail',
        component: () => import(/* webpackChunkName: "product-detail" */ '@/views/Product/ProductDetail.vue')
      },
      {
        path: 'search',
        name: 'Search',
        component: () => import(/* webpackChunkName: "search" */ '@/views/Search/Search.vue')
      },
      {
        path: 'cart',
        name: 'Shopping-cart',
        component: () => import(/* webpackChunkName: "cart" */ '@/views/Checkout/Cart.vue')
      },
      {
        path: 'orders',
        name: 'Orders',
        component: () => import(/* webpackChunkName: "orders" */ '@/views/Order/Orders.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'orders/:id',
        name: 'Order',
        component: () => import(/* webpackChunkName: "order" */ '@/views/Order/Order.vue'),
        meta: { requiresAuth: false }
      },
      {
        path: '/search-order',
        name: 'Search-order',
        component: () => import(/* webpackChunkName: "search-order" */ '@/views/Order/SearchOrder.vue'),
        meta: { requiresAuth: false }
      },
      {
        path: 'claims',
        name: 'Claims',
        component: () => import(/* webpackChunkName: "claims" */ '@/views/Claim/Claims.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'create-claim/:purchase_id',
        name: 'Create-claim',
        component: () => import(/* webpackChunkName: "create-claim" */ '@/views/Claim/CreateClaim.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'shipments/:id',
        name: 'Shipment',
        component: () => import(/* webpackChunkName: "shipment" */ '@/views/Shipments/Shipment.vue'),
        meta: { requiresAuth: false }
      },
      {
        path: '/about',
        name: 'About',
        component: () => import(/* webpackChunkName: "about" */ '@/views/About/About.vue')
      },
      {
        path: '/privacy-policies',
        name: 'Privacy-policies',
        component: () => import(/* webpackChunkName: "privacy-policies" */ '@/views/About/PrivacyPolicies.vue')
      },
      {
        path: '/terms-and-conditions',
        name: 'Terms-and-conditions',
        component: () => import(/* webpackChunkName: "terms-and-conditions" */ '@/views/About/TermsAndConditions.vue')
      },
      {
        path: '/account',
        name: 'Account',
        component: () => import(/* webpackChunkName: "account" */ '@/views/Account/Account.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/addresses',
        name: 'Addresses',
        component: () => import(/* webpackChunkName: "addresses" */ '@/views/Address/Addresses.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/address/update/:id',
        name: 'Update-address',
        component: () => import(/* webpackChunkName: "update-address" */ '@/views/Address/UpdateAddress.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/address/create',
        name: 'Create-address',
        component: () => import(/* webpackChunkName: "create-address" */ '@/views/Address/CreateAddress.vue'),
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/auth',
    redirect: '/auth/login',
    component: () => import(/* webpackChunkName: "auth" */ '@/layouts/AuthLayout.vue'),
    children: [
      {
        path: 'login',
        name: 'Login',
        component: () => import(/* webpackChunkName: "login" */ '@/views/Auth/Login.vue'),
        meta: { hideInSession: true }
      },
      {
        path: 'register',
        name: 'Register',
        component: () => import(/* webpackChunkName: "register" */ '@/views/Auth/Register.vue'),
        meta: { hideInSession: true }
      },
      {
        path: 'recover-account',
        name: 'Recover-account',
        component: () => import(/* webpackChunkName: "recover-account" */ '@/views/Auth/RecoverAccount.vue'),
        meta: { hideInSession: true }
      },
      {
        path: 'change-password',
        name: 'Change-password',
        component: () => import(/* webpackChunkName: "change-password" */ '@/views/Auth/ChangePassword.vue'),
        meta: { hideInSession: true }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

function validateChangePassword (to) {
  if (to.name !== 'Change-password') {
    return true
  }

  return !!to.query.email && !!to.query.token
}

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.state.auth.isAuthenticated
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (requiresAuth && !isAuthenticated) {
    return next({ name: 'Login' })
  }

  const hideInSession = to.matched.some(record => record.meta.hideInSession)
  if (isAuthenticated && hideInSession) {
    return next({ name: 'Home' })
  }

  if (!validateChangePassword(to)) {
    return next({ name: 'Recover-account' })
  }

  next()
})

export default router
